import customError from "@/errors/customError";


class authError extends customError {

	constructor(message, code=0, data={}) {
		// Pass remaining arguments (including vendor specific ones) to parent constructor
		super( message, code, data )
	}

}
export default authError;